'use strict';
var productBase = require('./base');

module.exports = {
    addToCartTile: productBase.addToCart
};
